<script lang="ts">
    import LL from "../../../i18n/i18n-svelte";
</script>

<div
    class="pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-[rgb(13_23_34/88%)] opacity-100 transition-opacity duration-300"
    aria-hidden={true}
>
    <div
        class="flex flex-col items-center justify-center space-y-3 rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] p-6 text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)]"
    >
        <p class="text-xl font-semibold text-[var(--nutrivera-shell-text)]">
            {$LL.mapEditor.entityEditor.drop()}
        </p>
    </div>
</div>
